import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {benefactorsApi} from '../api';
import {BenefactorSubscriptionsWithMetaModel, BenefactorSubscriptionsFilter, SubscriptionFilter} from '../model';

type BenefactorSubscriptionsState = {
  getSubscriptions: UseQueryResult<BenefactorSubscriptionsWithMetaModel, Error>;
};

export const useBenefactorSubscriptions = (
  benefactorId: string,
  filter: SubscriptionFilter = SubscriptionFilter.All,
): BenefactorSubscriptionsState => {
  const params: BenefactorSubscriptionsFilter = {
    filter,
    first: 50,
    includeTotalCount: true,
  };

  const getSubscriptions = useQuery<BenefactorSubscriptionsWithMetaModel, Error>({
    queryKey: ['benefactor', benefactorId, 'subscriptions', filter],
    queryFn: () => benefactorsApi.getBenefactorSubscriptions(benefactorId, params),
    enabled: !!benefactorId,
    staleTime: 60 * 1000, // 1 минута
  });

  return {
    getSubscriptions,
  };
};
